"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyEnum = exports.asyncApply = exports.apply = void 0;
// local
const enum_1 = require("./enum");
const getKeys_1 = require("./getKeys");
/**
 * Apply a function to each value of an object. Similar to lodash.mapValues but should preserve the typing of the keys.
 *
 * This allows one to define an object keys in an enum and then the resulting map should keep the same typing
 *
 * @param obj - The object to apply the function to
 * @param applyFunc - The function to apply
 * @returns The updated object
 */
function apply(obj, applyFunc) {
    const result = Object.keys(obj).reduce((acc, key, ind) => Object.assign(acc, {
        [key]: applyFunc(obj[key], key, obj, ind),
    }), {});
    return result;
}
exports.apply = apply;
/**
 * Apply a function to each value of an object. Similar to lodash.mapValues but should preserve the typing of the keys.
 *
 * This allows one to define an object keys in an enum and then the resulting map should keep the same typing
 *
 * @param obj - The object to apply the function to
 * @param applyFunc - The function to apply
 * @returns The updated object
 */
async function asyncApply(obj, applyFunc) {
    const entries = await Promise.all((0, getKeys_1.getKeys)(obj).map(async (key, ind) => ({
        key,
        value: await applyFunc(obj[key], key, obj, ind),
    })));
    const result = entries.reduce((acc, { key, value }) => Object.assign(acc, {
        [key]: value,
    }), {});
    return result;
}
exports.asyncApply = asyncApply;
/**
 * Convert a typescript enum to a mapping of [value]: [value] and then call apply on that
 *
 * @param enm - The object to apply the function to
 * @param applyFunc - The function to apply
 * @returns The updated object
 */
function applyEnum(enm, applyFunc) {
    const obj = (0, enum_1.createEnum)(Object.values(enm));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return apply(obj, applyFunc);
}
exports.applyEnum = applyEnum;
//# sourceMappingURL=apply.js.map